import PropTypes from "prop-types"

/**
 * PropTypes for MarginFormModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Function} onSave - Callback to save margin
 * @property {Object|null} [margin] - Existing margin to edit (null for create mode)
 * @property {Array<Object>} [locations] - Available locations for location scope
 * @property {string} [formError] - Server-side error to surface inline (e.g. overlap conflict)
 */
export const marginFormModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	margin: PropTypes.object,
	locations: PropTypes.array,
	formError: PropTypes.string,
}

/**
 * PropTypes for MarginDeleteModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Function} onConfirm - Callback to confirm deletion
 * @property {Object|null} [margin] - Margin to delete
 */
export const marginDeleteModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	margin: PropTypes.object,
}

/**
 * PropTypes for SimulatePriceModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Array<Object>} [tariffs] - Available OCPI tariffs to simulate against
 * @property {Array<Object>} [locations] - Available locations
 */
export const simulatePriceModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	tariffs: PropTypes.array,
	locations: PropTypes.array,
}

/**
 * PropTypes for Margins view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const marginsViewPropTypes = {}

/**
 * PropTypes for the Margins SidebarSection component.
 *
 * @property {Object|null} selectedMargin - Currently selected margin (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Total number of margins matching the current filters
 * @property {boolean} userIsAdmin - Whether the current user may edit/delete/toggle margins
 * @property {Function} onEdit - Opens the edit modal for the selected margin
 * @property {Function} onToggleActive - Activates/deactivates the selected margin
 * @property {Function} onDelete - Opens the delete confirmation for the selected margin
 */
export const marginsSidebarSectionPropTypes = {
	selectedMargin: PropTypes.object,
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	visibleCount: PropTypes.number.isRequired,
	userIsAdmin: PropTypes.bool.isRequired,
	onEdit: PropTypes.func.isRequired,
	onToggleActive: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
}
